var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-layout"},[_c('NavBar'),_c('div',{attrs:{"id":"map"}},[_c('router-view'),_c('div',{staticClass:"version"},[_c('span',[_vm._v(_vm._s(_vm.version))])])],1),_c('div',{staticClass:"sky-repeat"}),_c('HubPopup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }